// Main Classes
const root = (theme, styles) => ({
  alignSelf: 'center',
  marginBottom: theme.spacing(4),
  ...styles,
});

const content = (theme, styles) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  ...styles,
});

// Mobile Classes
// eslint-disable-next-line no-unused-vars
const mobile = (theme, styles) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
});

export {
  root,
  content,
  mobile,
};
